/**
 * Explore Landing - Redirects to search
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ExploreIndexPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/explore/search', { replace: true });
  }, [navigate]);

  return null;
};

export default ExploreIndexPage;
